// How PREVIOUS-meeting context is sourced for a meeting's live AI
// answers (backend/models/meeting.py's MeetingContextMode, backend/
// services/context_builder.py) — entirely independent of company
// selection: a meeting can use automatic/manual context with or
// without a company.
export const MEETING_CONTEXT_MODES = {
  NONE: 'none',
  AUTOMATIC: 'automatic',
  MANUAL: 'manual',
};

export const MEETING_CONTEXT_MODE_OPTIONS = [
  {
    value: MEETING_CONTEXT_MODES.NONE,
    label: 'None',
    description: 'Use only this meeting',
  },
  {
    value: MEETING_CONTEXT_MODES.AUTOMATIC,
    label: 'Automatic',
    description: 'AI finds relevant previous conversations',
  },
  {
    value: MEETING_CONTEXT_MODES.MANUAL,
    label: 'Manual',
    description: 'Choose previous meetings',
  },
];
